export default "/images/ifforsikringsagentur.avif?92cdff10abcbe6ca608a08e7a32bda23";